import * as importedPlans from './plans.json';
const { bcv_parser } = require('bible-passage-reference-parser/js/en_bcv_parser');
const bcv = new bcv_parser();

let cachedFormattedPlansObject = null;
const cachedFormattedPlanByName = {};

const Devotionals = {
    createDevotionalIndex: (plan, stage, item) => {
        return [ plan, stage, item];
    },
    getDevotional: (devotional) => {
        const [ plan, stage, item ] = devotional;
        const formattedPlan = Devotionals.getFormattedPlan(plan);
        return formattedPlan.stages[stage].passages[item];
    },
    getFormattedPlan: (planName) => {
        if (cachedFormattedPlanByName[planName]) return cachedFormattedPlanByName[planName];

        const currentPlan = importedPlans[planName];
        if (!currentPlan) return null;

        const formattedStages = currentPlan.stages.map((stage, stageIndex) => {
            const formattedVerses = stage.passages.map((section, sectionIndex) => {
                let osisRange;
                try {
                    osisRange = section.verses.includes('-') ? bcv.parse(section.verses).osis() : `${bcv.parse(section.verses).osis()}-${bcv.parse(section.verses).osis()}`;

                    if (osisRange.includes('James'))
                        osisRange = osisRange.replace('James','Jas').replace('James','Jas');
                    if (osisRange.includes('Psalm'))
                        osisRange = osisRange.replace('Psalm','Ps').replace('Psalm','Ps');

                } catch (error) {
                    osisRange = '';
                }
                try {
                    section.cross_references = section.cross_references.map(
                        (xref)=>{
                            return xref.replace('James','Jas').replace('James','Jas').replace('Psalm','Ps').replace('Psalm','Ps');
                        }
                    )
                } catch (error) {
                    section.cross_references = '';
                }

                return {
                    osisRange,
                    title: section.title,
                    commentary: section.commentary,
                    application: section.application,
                    meditation: section.meditation,
                    crossReferences: section.cross_references,
                    devotional: Devotionals.createDevotionalIndex(planName, stageIndex, sectionIndex)
                };
            });

            return {
                title: stage.title,
                passages: formattedVerses
            };
        });

        const formattedPlan = {
            stages: formattedStages,
            summary: currentPlan.summary,
            questions: currentPlan.overarchingquestions || currentPlan.overarching_questions
        };

        cachedFormattedPlanByName[planName] = formattedPlan;
        cachedFormattedPlansObject = null;
        return formattedPlan;
    },
    getFormattedPlans:() => {
        if (cachedFormattedPlansObject) return cachedFormattedPlansObject;

        const keys = Object.keys(importedPlans).filter(x => x !== 'default');
        cachedFormattedPlansObject = keys.reduce((acc, planName) => {
            const formattedPlan = Devotionals.getFormattedPlan(planName);
            if (!formattedPlan) return acc;
            acc[planName] = formattedPlan;
            return acc;
        }, {});

        return cachedFormattedPlansObject;
    }
}


export default Devotionals;
